module.exports = __webpack_public_path__ + "img/地图C-维多利亚女皇市场.6812cb34.png";